import { getFormattingLocale } from '@/composables/useLocale';

/** Format display values with the current app/market locale; callers choose precision and units. */
export function formatNumber(number: number, options?: Intl.NumberFormatOptions): string {
  // read per call: the locale changes at runtime
  return new Intl.NumberFormat(getFormattingLocale(), options).format(number);
}
